module.exports = "pegasus_template/assets/responsive.png";